let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8AP11")).then(() => parcelRequire('9vyF7'));